// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"190":"docs","191":"oxc-home","208":"oxc-me"}[chunkId] || chunkId) + "." + {"190":"6817a822","191":"f321a16a","208":"c0d30b7a","865":"415eb76e"}[chunkId] + ".js";
};